<template>
    <div :class="ischangePlan ? 'pricing-container' : 'pricing-popup-cover'" @click.self="ischangePlan ? '' : closeModal()">
      <span v-if="ischangePlan" class="reg-sub-title"> {{fixDisplayLabel('subscription_pages_steps_text')}}</span>
      <div :class="ischangePlan ? 'pricing-options' : 'pricing-popup'">
        <div class="pricing-header">
            <h2>{{ $t('plan_select_page_title')}}</h2>
            <p>{{$t('plan_select_page_subtitle')}} 🎉</p>
        </div>
        
        <div class="pricing-options" v-for="plan in defaultPlans" :key="plan.durationCode">
            <div 
            class="pricing-option"
            :class="{'highlighted': plan.durationCode === getCurrentSelectedPlan.durationCode}"
            @click="selectOption(plan)"
            >
            <div class="free-months-badge" v-if="plan.durationCode === 'P1Y'">
                <span :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">{{ getOriginalSavePrice(plan.promoTitle)}}</span>
                <img src="../assets/images/gift.svg" alt="''"/>
            </div>
            <div class="option-content-yearly" :class="{'highlighted': plan.durationCode === getCurrentSelectedPlan.durationCode}">
                <h3 :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">{{ $t(plan.planId) }}</h3>
                <p v-if="plan.durationCode === 'P1Y'"
                class="price" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">{{ getYearlyPrice('register_page_box_subtitle_yearly') }}
                </p>
                <p v-else class="price" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">{{ getMonthlyPrice() }}</p>
            </div>
            </div>
            
            <!-- <div 
            class="pricing-option"
            :class="{ 'selected': selectedOption === 'daily' }"
            @click="closeModal('daily')"
            >
            <div class="option-content">
                <h3>1 jour</h3>
                <p class="price">0,99€ / jour</p>
            </div>
            </div> -->
        </div>
        <SubmitButton class="set-apdding" v-if="ischangePlan" :label="$t('coupons_popup_button')" :isLoading="false" @click="closeModal"/>
      </div>
    </div>
  </template>  
  <script>
  import PriceMixin from '../mixins/price';
  import SubmitButton from '../components/SubmitButton.vue';
  import { mapGetters } from "vuex";
  export default {
		mixins: [PriceMixin],
    name: 'PricingPopup',
    components: {
			"SubmitButton": SubmitButton,
    },
    computed: {
      ...mapGetters(['getAllPlans', 'getCurrentSelectedPlan']),
      defaultPlans() {
        return this.getAllPlans;
      },
      ischangePlan() {
        return this.$route.name === 'changeSubscriptionPlan';
      },
      currentSelectedPlan() {
        return this.getCurrentSelectedPlan;
      }
    },
    methods: {
      fixDisplayLabel(label) {
        return this.$t(label, {step: 1});
      },
      routeToChangePlan: function() {
        this.$router.replace({path: '/changePlan'})
      },
      selectOption(value) {
        if(Object.keys(value).length) {
          this.$store.commit('setCurrentSelectedPlan', value);
        }
        if (!this.ischangePlan) {
          this.closeModal();
        }
      },
      closeModal() {
        if(this.$route.name === 'changeSubscriptionPlan') {
          this.routeToChangePlan();
        } else {
          this.$emit('togglePricingModal');
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .set-apdding {
    margin-block: 20px;
  }
  .reg-sub-title {
    font-size: 20px;
    font-family: "Nunito-Regular";
    color: #020076;

    @media (orientation: portrait) {
      font-size: 14px;
      line-height: 2;
    }
  }
  .pricing-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 10px;

    @media (max-width: 1024px) {
      margin-top: 10%;
    }

    .pricing-options {
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 380px;
    }
  }
  .pricing-popup-cover {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 10000;
  }
  .pricing-popup {
    position: absolute;
    background-color: white;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 90%;
    max-width: 400px;
    padding: 16px;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
  
    @media (orientation: landscape) {
        top: 50%;
        left: 50%;
        bottom: auto;
        transform: translate(-50%, -50%);
    }
    @media screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        top: 50%;
        left: 50%;
        bottom: auto;
        transform: translate(-50%, -50%);
    }
}

  
  .pricing-header {
    color: #020076;
    /* padding: 16px 20px; */
    text-align: center;
    padding-bottom: 0px;
    font-family: "Nunito-Regular";
  }
  
  .pricing-header h2 {
    margin: 0;
    font-size: 26px;
    font-weight: bold;
    font-family: "Nunito-ExtraBold";
  }
  
  .pricing-header p {
    margin: 4px 0 0;
    font-size: 14px;
    opacity: 0.9;
    font-family: "Nunito-Regular";
  }
  
  .pricing-options {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .pricing-option {
    border-radius: 12px;
    border: 2px solid #020076;
    cursor: pointer;
    position: relative;
    padding: 10px;
    font-family: "Nunito-Regular";
    color: #020076;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  
    &.highlighted {
      background-color: #020076;
      color: white;
    }
  }
  .option-content-yearly {
    font-family: "Nunito-Regular";
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    justify-content: space-between;
    color: #020076;
   
    &.highlighted {
      color: white;
      h3 {
        color: white;
      }
      p {
        color: white;
      }
    }
    h3 {
      font-family: "Nunito-ExtraBold";
    }
  }
  /* .option-content {
    font-family: "Nunito-Regular";
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #020076;
    flex-direction: column;
    h3 {
      font-family: "Nunito-ExtraBold";
    }
  }
  .option-content h3 {
    font-family: "Nunito-Regular";
    margin: 0;
    font-size: 18px;
    font-weight: bold;
  }
  
  .option-content .price {
    margin: 0;
    font-size: 14px;
    font-family: "Nunito-Regular";
  } */
  
  .free-months-badge {
    font-family: "Nunito-Regular";
    background-color: #FFA726;
    color: #020076;
    font-weight: bold;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
    margin-bottom: 2px;
    width: fit-content;
    display: flex;
    flex-direction: row;
    gap: 5px;
  }
  
  /* Responsive adjustments */
  @media (max-width: 480px) {
    .pricing-popup {
      max-width: 100%;
      width: 100%;
      bottom: 0px;
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    
    /* .option-content {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      align-items: center;
    } */
  }
  </style>